export default function MvpROI() {
  return (
    <section id="roi" className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-[#071210] flex items-center justify-center">
            <span className="text-emerald-400 text-xs font-bold">VI</span>
          </div>
          <span className="text-stone-400 text-xs uppercase tracking-widest font-medium">Parte VI</span>
        </div>
        <h2 className="text-3xl font-bold text-stone-900 mb-2">Análise de Retorno — Fase 1</h2>
        <p className="text-stone-500 mb-10 text-base">O impacto direto da Fase 1 no tamanho da equipe necessária para operar a captação de recursos e no custo operacional anual do instituto.</p>

        {/* Premissa */}
        <div className="mb-10 p-5 rounded-xl border border-stone-200 bg-stone-50">
          <h3 className="text-sm font-semibold text-stone-800 mb-3 flex items-center gap-2">
            <i className="ri-information-line text-emerald-500 text-sm w-4 h-4 flex items-center justify-center"></i>
            Premissas do Cálculo
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { label: 'Salário analista de captação em Manaus/AM', value: 'R$ 5.500/mês', sub: 'Catho 2025, nível pleno' },
              { label: 'Encargos e benefícios (CLT)', value: '+70%', sub: 'Total por analista: R$ 9.350/mês' },
              { label: 'Custo anual por analista contratado', value: 'R$ 112.200/ano', sub: 'Base de comparação do ROI' },
            ].map((p) => (
              <div key={p.label} className="p-3 rounded-lg bg-white border border-stone-100">
                <p className="text-stone-400 text-xs mb-1">{p.label}</p>
                <p className="text-stone-900 font-bold text-base">{p.value}</p>
                <p className="text-stone-400 text-xs">{p.sub}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Resumo ROI */}
        <div className="p-6 rounded-2xl border border-stone-200 bg-stone-50">
          <h3 className="text-base font-semibold text-stone-800 mb-6">Resumo do Retorno sobre Investimento — Fase 1</h3>
          <div className="space-y-4">
            {[
              {
                label: 'Fase 1 — Submit.AI (R$ 357.000)',
                economia: 'Até R$ 336.600/ano em pessoal',
                payback: 'Payback em ~12,7 meses',
                bar: 100,
                color: 'bg-emerald-400',
                roi: 'ROI positivo no 2º ano de operação',
              },
            ].map((row) => (
              <div key={row.label} className="p-4 rounded-xl border border-stone-100 bg-white">
                <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
                  <span className="text-stone-700 text-sm font-semibold">{row.label}</span>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-2.5 py-0.5 rounded-full bg-emerald-100 text-emerald-700 text-xs font-semibold">{row.economia}</span>
                    <span className="px-2.5 py-0.5 rounded-full bg-stone-200 text-stone-600 text-xs font-semibold">{row.payback}</span>
                    <span className="px-2.5 py-0.5 rounded-full bg-amber-100 text-amber-700 text-xs font-semibold">{row.roi}</span>
                  </div>
                </div>
                <div className="w-full bg-stone-200 rounded-full h-2">
                  <div className={`${row.color} h-2 rounded-full transition-all`} style={{ width: `${row.bar}%` }}></div>
                </div>
              </div>
            ))}
          </div>

          {/* Projeção 3 anos */}
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { ano: 'Ano 1', desc: 'Investimento + operação', valor: '-R$ 357.000', sub: 'Fase de implantação e início de uso', color: 'text-red-600' },
              { ano: 'Ano 2', desc: 'Economia acumulada', valor: '-R$ 20.400', sub: 'Payback atingido (~12,7 meses de uso)', color: 'text-amber-600' },
              { ano: 'Ano 3', desc: 'Retorno líquido acumulado', valor: '+R$ 316.200', sub: 'Apenas pela redução de pessoal operacional', color: 'text-emerald-700' },
            ].map((item) => (
              <div key={item.ano} className="p-4 rounded-xl border border-stone-100 bg-white text-center">
                <p className="text-stone-400 text-xs mb-1">{item.ano}</p>
                <p className={`font-bold text-lg ${item.color}`}>{item.valor}</p>
                <p className="text-stone-700 text-xs font-semibold mt-1">{item.desc}</p>
                <p className="text-stone-400 text-xs mt-1 leading-relaxed">{item.sub}</p>
              </div>
            ))}
          </div>

          <p className="text-stone-400 text-xs mt-4 italic">
            Cálculo baseado na substituição de analistas CLT em Manaus/AM a R$ 9.350/mês (salário + encargos). Não considera o aumento de receita por aprovação de projetos adicionais, o que tornaria o retorno ainda mais expressivo.
          </p>
        </div>
      </div>
    </section>
  );
}
